import { Network } from "lucide-react";

export const hrMenuItems =  [
   {
      id: "organization",
      title: "Organization",
      // url: "/dashboard/organization",
      type: "collapse",
      role: ["Admin", "HR"],

      icon: <Network />,
      activeIco: <Network />,
      children: [
        {
          id: "designation",
          title: "Designation",
          parent: "organization",
          url: "/dashboard/organization/designation",
          type: "item",
          role: ["Admin", "HR"],
        },
        {
          id: "department",
          parent: "organization",
          title: "Department",
          url: "/dashboard/organization/department",
          type: "item",
          role: ["Admin", "HR"],
        },
        {
          id: "shift",
          title: "Shift",
          url: "/dashboard/organization/shift",
          parent: "organization",
          type: "item",
          role: ["Admin", "HR"],
        },
        {
          id: "shift-history",
          title: "Shift History",
          url: "/dashboard/organization/shift-history",
          parent: "organization",
          type: "item",
          role: ["Admin", "HR"],
        },
        {
          id: "holiday-list",
          title: "Holiday List",
          url: "/dashboard/organization/holiday-list",
          parent: "organization",
          type: "item",
          role: ["Admin", "HR"],
        },

        {
          id: "employee",
          title: "Employee",
          url: "/dashboard/organization/employee",
          parent: "organization",
          type: "item",
          role: ["Admin", "HR"],
        },

        // {
        //   id: "attendance",
        //   title: "Attendance",
        //   url: "/dashboard/organization/attendance",
        //   parent: "organization",
        //   type: "item",
        //   role:['Admin'],

        // },
      ],
    },
]